import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyView } from './empty-view';
export var EmptyViewContainer = function () { return _jsx(EmptyView, {}); };
